module.exports = __webpack_public_path__ + "static/media/imgop_WinterWheatStraw_StretchedTiff.8b732f22.jp2";